<template>
<!-- Main Sidebar -->
		<a-layout-sider
			collapsible
			class="sider-primary"
			breakpoint="lg"
			collapsed-width="170"
			width="240"
			v-model="collapsed"
			:collapsed="sidebarCollapsed"
			@collapse="$emit('toggleSidebar', ! sidebarCollapsed)"
			:trigger="null"
			theme="dark"
			:style="{ backgroundColor: 'transparent',}"
		>
			<!-- <a-layout-sider
				collapsible
				class="sider-primary"
				:class="['ant-layout-sider-' + sidebarColor, 'ant-layout-sider-' + sidebarTheme]"
				collapsed-width="170"
				v-model="collapsed"
				:trigger="null"
				theme="dark"
			> -->
				<div class="brand"><img src="images/favicon.png" alt=""> <span>大虞建造</span></div>
				<hr>

		<!-- <a-menu
			@openChange="onOpenChange"
			mode="inline"
		>
			<a-sub-menu class="mt20" v-for="items in menu" :key="items.key" style="border: 1px solid white ;border-radius: 10px;background-color: white;">
				<span slot="title"><a-icon type="mail" /><span>{{items.module}}</span></span>
				<a-menu-item v-for="item in items.menu" :key="item.key" @click="goSubPage(item.link)" >
					<div class="mt10 pl30">
						<a-icon :type="item.icon" class="mr10"/><span>{{ item.name }}</span>
					</div>
				</a-menu-item>
			</a-sub-menu>
		</a-menu> -->

		<a-menu
			:default-selected-keys="['1']"
			:default-open-keys="['sub1']"
			mode="inline"
			theme="dark"
		>
			
			<a-sub-menu v-for="items in menu" :key="items.key">
				<span slot="title">
					<!-- <a-icon type="mail" /> -->
					<span>{{items.module}}</span>
				</span>
				<a-menu-item  v-for="item in items.menu" :key="item.key" @click="goSubPage(item.link)">
					<a-icon :type="item.icon" class="mr10"/><span>{{ item.name }}</span>
				</a-menu-item>
			</a-sub-menu>
			
		</a-menu>

	</a-layout-sider>
</template>

<script>
	export default ({
		props: {
			// Sidebar collapsed status.
			sidebarCollapsed: {
				type: Boolean,
				default: false,
			},
			
			// Main sidebar color.
			sidebarColor: {
				type: String,
				default: "dark",
			},
			
			// Main sidebar theme : light, white, dark.
			sidebarTheme: {
				type: String,
				default: "dark",
			},
		},
		data() {
			return {
				menu:[],
				rootSubmenuKeys: ['sub1', 'sub2', 'sub3', 'sub4', 'sub5', ],
				openKeys: ['sub1'],
				collapsed: false,
			}
		},
		async created(){
			this.getMenuList()
		}, 
		methods:{
			toggleCollapsed(){
				this.collapsed = !this.collapsed;
			},
			async getMenuList(){
				let rs = await this.$api.getIndex()
				if(rs.err == 0){
					this.menu = []
					for(var i = 1; i <= rs.count;i++){
						let item = rs.data.filter(it => it.interface_id == i)
						if((item != null)&&(item.length != 0)){
							let as = {}
							as.module = item[0].module
							as.key = item[0].interface_id
							as.menu = item
							this.menu.push(as)
						}
					}
				}
			},
			onOpenChange(openKeys) {
				const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
					if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
					this.openKeys = openKeys;
				} else {
					this.openKeys = latestOpenKey ? [latestOpenKey] : [];
				}
			},
			goSubPage(link){
				this.$router.push(link)
			}
		}
	})

</script>
<style>
.brand {
	padding-top: 25px!important;
}
#components-layout-demo-top-side .logo {
	width: 120px;
	height: 31px;
	background: rgba(255, 255, 255, 0.2);
	margin: 16px 28px 16px 0;
	float: left;
	
}
.sider-primary {
	margin: 0px!important;
	height: 100%!important;
	border-radius: 0px!important;
	padding: 0px!important;
}
</style>
